<template>
    <b-card
        bg-variant="light"
        header-class="card-header p-3  pt-3 h5"
        header-text-variant="black"
        header-tag="header"
    >
        <div slot="header">
            <div class="d-flex align-items-center">
                <div>
                    <i class="mdi mdi-account-circle " />
                    Project Details
                </div>
                <div class="pl-3">
                    <button
                        class="btn btn-info"
                        @click="onOpenCreateOrUpdateModal"
                    >
                        <i class="fas fa-edit" /> Edit
                    </button>
                </div>
            </div>
        </div>
        <create-or-update
            :modal-show="isCreateOrUpdateModalVisible"
            :project="project"
            @close="onCloseCreateOrUpdateModal"
        />

        <div class="card">
            <div class="grid2x5">
                <div>
                    <p class="mb-2 font-14">
                        <strong>Type of surface to be rated:</strong>
                        <span class="ml-2">{{
                            snakeCaseToText(project.surfaceTypeToRate) || '-'
                        }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Project name:</strong>
                        <span class="ml-2">{{ project.name || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Company name:</strong>
                        <span class="ml-2">{{
                            project.companyName || '-'
                        }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>City:</strong>
                        <span class="ml-2">{{ project.city || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Plot:</strong>
                        <span class="ml-2">{{ project.plot || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Weather file:</strong>
                        <span class="ml-2 ">{{ project.weatherFile }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Address:</strong>
                        <span class="ml-2">{{ project.address || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Climate:</strong>
                        <span class="ml-2">{{ project.climate || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Block:</strong>
                        <span class="ml-2">{{ project.block || '-' }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Mass Per Unit:</strong>
                        <span class="ml-2">{{
                            massPerUnitLabels[project.massPerUnit] || '-'
                        }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>Wall Bridge Percentage:</strong>
                        <span class="ml-2">{{
                            project.wallBridgePercentage || '-'
                        }}</span>
                    </p>
                </div>
                <div>
                    <p class="mb-2 font-14">
                        <strong>U-Value of wall bridge:</strong>
                        <span class="ml-2">{{
                            project.uValueOfWallBridge || '-'
                        }}</span>
                    </p>
                </div>
            </div>
        </div>
    </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CreateOrUpdate from '@/components/projects/CreateOrUpdate.vue';

export default {
    components: {
        CreateOrUpdate
    },

    data() {
        return {
            isCreateOrUpdateModalVisible: false,
            projectId: this.$route.params.id,
            massPerUnitLabels: { 110: '> 100', 90: '< 100' },
            project: {}
        };
    },

    computed: {
        ...mapGetters({
            getProjectById: 'projects/getById'
        })
    },

    watch: {
        projectId() {
            if (!this.projectId) {
                return;
            }

            this.project = this.getProjectById(this.projectId);
        }
    },

    async created() {
        await this.fetchProjects();
        this.project = this.getProjectById(this.projectId);
    },

    methods: {
        ...mapActions({
            fetchProjects: 'projects/fetchProjects',
            getProject: 'projects/show'
        }),

        async onCloseCreateOrUpdateModal() {
            this.project = this.getProjectById(this.projectId);

            this.isCreateOrUpdateModalVisible = false;
        },

        snakeCaseToText(text) {
            return typeof text !== 'string'
                ? ''
                : `${text.charAt(0).toUpperCase()}${text
                      .replace(/_/g, ' ')
                      .slice(1)}`;
        },

        async onOpenCreateOrUpdateModal() {
            this.project = this.getProjectById(this.projectId);

            this.isCreateOrUpdateModalVisible = true;
        }
    }
};
</script>
